/*  ========================================================================
    # Scripts - Video Lightbox
    ========================================================================  */

const VideoLightbox = {
  cfg: {
    body: document.querySelector('body'),
    lightboxElements: document.querySelectorAll('[data-lightbox]'),
    lightboxToggleElements: document.querySelectorAll('[data-lightbox-target]')
  },

  /**
   * Handle lightbox toggle
   */
  handleLightboxToggle() {
    this.cfg.lightboxToggleElements.forEach(element => {
      const target = element.getAttribute('data-lightbox-target');
      const lightbox = document.querySelector(`[data-lightbox="${target}"]`);
      const closeElement = lightbox.querySelector('.c-video-lightbox__close');
      const video = lightbox.querySelector('video');

      element.addEventListener('click', () => {
        lightbox.showModal();
        this.cfg.body.style.overflow = 'hidden';
      });

      closeElement.addEventListener('click', () => {
        lightbox.close();
        video.pause();
        this.cfg.body.style.overflow = 'auto';
      });
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.lightboxElements && this.cfg.lightboxToggleElements) {
      this.handleLightboxToggle();
    }
  }
};

export default VideoLightbox;
